export default {"src":"/_next/static/media/Major-badge.d6a5a609.svg","height":100,"width":100};